import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEnrichmentProperties } from './useEnrichmentProperties';
import { BasePanel } from '../Panel/BasePanel';
import { jsx as _jsx } from "react/jsx-runtime";
export function EnrichmentPropertiesFooter() {
  const {
    canEnrich,
    isErrorEnrichment,
    isLoading,
    onEnrich
  } = useEnrichmentProperties();
  const ButtonMessage = () => {
    if (isErrorEnrichment) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.panel.retry"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrichmentProperties.panel.save"
    });
  };
  return /*#__PURE__*/_jsx(BasePanel.Footer, {
    children: /*#__PURE__*/_jsx(BasePanel.FooterActions, {
      alignItems: "center",
      blockSize: "100%",
      flexGrow: 1,
      children: /*#__PURE__*/_jsx(BasePanel.ButtonUsageCheck, {
        action: "DATASET_ENRICHMENT",
        disabled: !canEnrich,
        isLoading: isLoading,
        numberOfOperations: 1,
        onClick: onEnrich,
        children: /*#__PURE__*/_jsx(ButtonMessage, {})
      })
    })
  });
}